import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BN from 'bignumber.js';
import PercentageButton from '../percentage-button';

const PercentageButtons = ({ percentArray, balance, disabled, onClick }) => {
  const [percent, setPercent] = useState(0);

  const onClickButton = (value) => {
    if (disabled) {
      return;
    }
    if (value === 100) {
      onClick({ amount: balance, percent: value, amountBN: new BN(balance) });
      setPercent(value);
      return;
    }

    const amountBN = new BN(balance).times(value / 100);
    const amountLabel = amountBN.toFixed(0, BN.ROUND_DOWN);

    onClick({ amount: amountLabel, percent: value, amountBN });
    setPercent(value);
  };

  return percentArray.map((item) => (
    <PercentageButton
      key={item}
      text={item}
      active={percent === item}
      onClick={() => onClickButton(item)}
    />
  ));
};

PercentageButtons.propTypes = {
  percentArray: PropTypes.array,
  balance: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

PercentageButtons.defaultProps = {
  percentArray: [25, 50, 75, 100],
  balance: '0',
  onClick: () => {},
  disabled: false,
};

export default PercentageButtons;
